



















import { defineComponent, PropType, toRef } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import useModal from "@/hooks/useModal";
import CustomScroll from "@/components/CustomScroll";

export default defineComponent({
  name: "BaseConfirm",
  components: { CustomScroll },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    title: { type: String as PropType<TranslateResult> },
    scrollable: { type: Boolean, default: true },
    classWrapper: { type: String },
    modal: { type: Boolean, default: false },
    value: { type: Boolean, required: true },
  },
  setup(props) {
    const { modalClose } = useModal(toRef(props, "value"), props.modal);

    return {
      modalClose,
    };
  },
});
